import { Component } from '@angular/core';
import {
    ErrorInterface,
    InsurancePolicyActionService, NewModalModule,
    NewModalRef as ModalRef,
    ProductPremiumDeterminingFactorResponseInterface,
    PurchasedProductInterface,
} from 'outshared-lib';
import { mapFactorIdRequest } from '../mappers';
import { CommonModule } from '@angular/common';
import {
    WucBalloonModule,
    WucButtonModule,
    WucIconUiModule, WucLinkModule,
    WucListItemModule,
    WucListModule,
} from '@inshared/website-ui-components';

@Component({
    selector: 'ins-insurance-cancel-added-premium-determining-factor-modal',
    standalone: true,
    imports: [
        CommonModule,
        NewModalModule,
        WucButtonModule,
        WucIconUiModule,
        WucBalloonModule,
        WucListItemModule,
        WucListModule,
        WucLinkModule,
    ],
    styleUrls: ['insurance-cancel-added-premium-determining-factor.modal.scss'],
    templateUrl: 'insurance-cancel-added-premium-determining-factor.modal.html',
})
export class InsuranceCancelAddedPremiumDeterminingFactorModal {

    public purchasedProduct: PurchasedProductInterface;
    public premiumDeterminingFactor: ProductPremiumDeterminingFactorResponseInterface;
    public isDisabled: boolean;
    public errors: ErrorInterface[];

    constructor(
        private insurancePolicyActionService: InsurancePolicyActionService,
        private modalRef: ModalRef<InsuranceCancelAddedPremiumDeterminingFactorModal>,
    ) {
        this.isDisabled = false;
        this.errors = [];
    }

    public get factorDescription(): string {
        return this.premiumDeterminingFactor?.modifiableFactorFuture?.factorDescription ?? 'Aanpassing';
    }

    public onCancelAddedPremiumDeterminingFactor(): void {
        this.insurancePolicyActionService
            .cancelAddedPremiumDeterminingFactor$({
                factorId: mapFactorIdRequest(this.premiumDeterminingFactor.factorId),
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            })
            .subscribe({
                next: () => this.onCancelAddedPremiumDeterminingFactorSuccess(),
                error: (errors) => this.onCancelAddedPremiumDeterminingFactorError(errors),
            });

        this.isDisabled = true;
        this.errors = [];
    }

    private onCancelAddedPremiumDeterminingFactorSuccess(): void {
        this.isDisabled = false;
        this.close();
    }

    private onCancelAddedPremiumDeterminingFactorError(errors: ErrorInterface[]): void {
        this.errors = errors;
        this.isDisabled = false;
    }

    public close(): void {
        this.modalRef.close();
    }
}
